module.exports = __webpack_public_path__ + "static/img/2.028e7d62.png";